export default __webpack_public_path__ + "static/media/submit-success.4e384b53.svg";